import { FormulierDto, PairedDocumentDto } from '../../api';

export type PreAdviesFormulierFormData = FormulierDto & {
  toestemmingsverklaring: File[];
};

export type FormulierState = {
  isLoading: boolean;
  isSuccessful: boolean;
  isComplete: boolean;
  formulieren?: PairedDocumentDto[];
};

export const initialFormulierState: FormulierState = {
  isLoading: false,
  isSuccessful: false,
  isComplete: false,
  formulieren: undefined,
};
